import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const OurCommunity = () => {
    useEffect(() => {
        AOS.init({ duration: 500, once: false });
    }, []);

    function viewSocial(index: number): void {
        if (index === 0) {
            window.open('https://x.com/TinyBlock_io')
        }
        if (index === 1) {
            window.open('http://t.me/tinyblock_io')
        }
        if (index === 2) {
            window.open('https://discord.gg/M2TaS3ZQhY')
        }
    }

    return (
        <div className="main-community">
            <div className="container">
                <div className="wrap-community">
                    <div className="title" data-aos="fade-up">
                        OUR Community
                    </div>
                    <div className="desc" data-aos="fade-up" data-aos-delay="200">
                        We're having fun while earning good income in this Web3 space. It'd be great if you join us!
                    </div>
                    <div className="wrap-columns">
                        <div className="columns">
                            {[{ img: 'our-1.png', count: '30k+', label: 'Twitter Followers' },
                            { img: 'our-2.png', count: '20k+', label: 'Telegram Members' },
                            { img: 'our-3.png', count: '5k+', label: 'Discord Members' }].map((item, index) => (
                                <div onClick={() => viewSocial(index)} className="colum w-4-1" key={index} data-aos="zoom-in" data-aos-delay={index * 200}>
                                    <div className="guide-social">
                                        <div className="o-left">
                                            <img src="./images/o-left.png" alt="" />
                                        </div>
                                        <div className="o-right">
                                            <img src="./images/o-right.png" alt="" />
                                        </div>
                                        <div className="box-img">
                                            <img src={`./images/${item.img}`} alt="" /> {item.count}
                                        </div>
                                        <div className="text">
                                            <img src="./images/legit.png" alt="" /> {item.label}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurCommunity;
